// Gatsby browser code
import "./src/theme/theme.scss";

// You can also wrap with TSX components like so
// import { WrapPageElement, WrapRootElement } from '../src/components';
// export const wrapRootElement = WrapRootElement;